import React from 'react';
import PropTypes from 'prop-types';
import './CampaignCompleteDialog.css';

/**
 * Dialog shown when an outreach campaign has completed.
 * Offers the user options to re-run the same campaign or start a new one.
 */
export const CampaignCompleteDialog = ({
  open,
  onRunAgain,
  onNewCampaign,
  onClose,
  loading = false,
}) => {
  if (!open) return null;

  const handleOverlayClick = (e) => {
    // Close if overlay (not dialog content) is clicked
    if (e.target.classList.contains('ccd-overlay')) {
      onClose?.();
    }
  };

  return (
    <div 
      className="ccd-overlay" 
      onClick={handleOverlayClick}
      onKeyDown={(e) => e.key === 'Escape' && onClose?.()}
      role="presentation"
      tabIndex="-1"
    >
      <div className="ccd-dialog" role="dialog" aria-modal="true">
        <button className="ccd-close" onClick={onClose} aria-label="Close dialog">
          ×
        </button>
        <h2 className="ccd-title">Campaign completed!</h2>
        <p className="ccd-message">
          Great job! Would you like to run another campaign or re-run this one?
        </p>
        <div className="ccd-buttons">
          <button
            className="ccd-btn ccd-secondary"
            onClick={onRunAgain}
            disabled={loading}
          >
            {loading ? <span className="spinner" /> : 'Run Again'}
          </button>
          <button
            className="ccd-btn ccd-primary"
            onClick={onNewCampaign}
            disabled={loading}
          >
            {loading ? <span className="spinner" /> : 'New Campaign'}
          </button>
        </div>
      </div>
    </div>
  );
};

CampaignCompleteDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onRunAgain: PropTypes.func.isRequired,
  onNewCampaign: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};
